import PropTypes from 'prop-types';
import { useId, useState } from 'react';
import style from './info-tip.module.scss';

// Info tooltip for section headers. The trigger is a small ⓘ icon
// that reveals an explanatory tooltip on hover / focus. Keeps card
// headers clean while making detailed guidance available on demand.
//
// A11y: tooltip text is linked to the trigger via aria-describedby,
// ensuring screen readers announce it when the trigger gets focus.
function InfoTip({ content, label = 'More information' }) {
  const tooltipId = useId();
  const [open, setOpen] = useState(false);

  return (
    <span className={style.wrapper}>
      <button
        type="button"
        className={style.trigger}
        aria-label={label}
        aria-describedby={tooltipId}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        onClick={() => setOpen(o => !o)}
      >
        <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="1.4" />
          <circle cx="8" cy="4.5" r="0.9" fill="currentColor" />
          <path d="M8 7V12" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
        </svg>
      </button>
      <span id={tooltipId} role="tooltip" className={`${style.bubble} ${open ? style.open : ''}`}>
        {content}
      </span>
    </span>
  );
}

InfoTip.propTypes = {
  content: PropTypes.node.isRequired,
  label: PropTypes.string,
};

export default InfoTip;
